import { Box, makeStyles } from "@material-ui/core";
import { useState, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Loading } from "../../parts/Loading";
import { StyledTab, StyledTabs } from "./AdminSettingPanel";
import CoPilotAircraftLinkage from "./CoPilotAircraftLinkage";
import CoPilotDisplaySetting from "./CoPilotDisplaySetting";
import CoPilotSettingList from "./CoPilotSettingList";

const useStyles = makeStyles({
	settingTopBox: {
		display: 'flex',
		flexDirection: 'column',
	},
	settingTab: {
	},
	settingBody: {
		flexGrow: 1,
		marginTop: '-1px',
		border: '1px solid #a7a7a7',
		overflow: 'hidden',
	},
});

export function CoPilotSettingBox({changeAircraftSetting}) {
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const classes = useStyles();
	const {t} = useTranslation();

	return (
		<div className={classes.settingTopBox} style={{ height: '100%' }}>
			<Box className={classes.settingTab}>
				<StyledTabs
					value={value}
					onChange={handleChange}
				>
					<StyledTab label={t('FOSTER-CoPilot List')} />
					<StyledTab label={t('FOSTER-CoPilot - Aircraft Linkage')} />
					<StyledTab label={t('Display Setting')} />
				</StyledTabs>
			</Box>
			<Box className={classes.settingBody}>
				<Suspense fallback={<Loading/>}>
					{value === 0 && <CoPilotSettingList changeAircraftSetting={changeAircraftSetting}/>}
					{value === 1 && <CoPilotAircraftLinkage />}
					{value === 2 && <CoPilotDisplaySetting />}
				</Suspense>
			</Box>
		</div>
	);
}
